import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Use_Of_Reference_Material_Table = ({ setEdit }) => {
  const data = [
    {
      date: "1 Jan 2025",
      parameter: "IM",
      certifiedValue: 3.25,
      method: "IS 1350 Part-I",
      obs01: 3.25,
      obs02: 3.3,
      average: 26.5,
      testedBy: "0.07",
      remark: "",
      action: "👁️",
    },
    {
      date: "2 Jan 2025",
      parameter: "VM",
      certifiedValue: 3.25,
      method: "IS 1350 Part-II",
      obs01: 3.25,
      obs02: 3.3,
      average: 26.5,
      testedBy: "0.07",
      remark: "",
      action: "👁️",
    },
    {
      date: "3 Jan 2025",
      parameter: "ASH",
      certifiedValue: 3.25,
      method: "IS 1350 Part-I",
      obs01: 3.25,
      obs02: 3.3,
      average: 26.5,
      testedBy: "0.07",
      remark: "",
      action: "👁️",
    },
    {
      date: "4 Jan 2025",
      parameter: "GCV",
      certifiedValue: 3.25,
      method: "IS 1350 Part-II",
      obs01: 3.25,
      obs02: 3.3,
      average: 26.5,
      testedBy: "0.07",
      remark: "",
      action: "👁️",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Date</th>
                <th>Test Parameter</th>
                <th>Certified Value</th>
                <th>Test Method</th>
                <th>OBS 01</th>
                <th>OBS 02</th>
                <th>Avg.</th>
                <th>Tested By</th>
                <th>Remark</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.parameter}</td>
                  <td>{row.certifiedValue}</td>
                  <td>{row.method}</td>
                  <td>{row.obs01}</td>
                  <td>{row.obs02}</td>
                  <td>{row.average}</td>
                  <td>{row.testedBy}</td>
                  <td>{row.remark || "-"}</td>
                  <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faEye} className="edit_icon" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Use_Of_Reference_Material_Table;
